import { render, staticRenderFns } from "./ParamSubheader.vue?vue&type=template&id=2ae1b8e2&"
import script from "./ParamSubheader.vue?vue&type=script&lang=ts&"
export * from "./ParamSubheader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports